export interface Country {
  /** ISO 3166-1 alpha-3 country code, e.g. 'GBR'. Sent to the backend as `address.country`. */
  value: string
  /** ISO 3166-1 alpha-2 country code, e.g. 'GB'. Used to derive the flag emoji. */
  alpha2: string
  /** Common English country name. */
  name: string
}

/**
 * Full list of ISO 3166-1 countries accepted by the business waitlist backend's
 * `address.country` whitelist, sorted alphabetically by name.
 */
export const countries: readonly Country[] = [
  { value: 'AFG', alpha2: 'AF', name: 'Afghanistan' },
  { value: 'ALA', alpha2: 'AX', name: 'Åland Islands' },
  { value: 'ALB', alpha2: 'AL', name: 'Albania' },
  { value: 'DZA', alpha2: 'DZ', name: 'Algeria' },
  { value: 'ASM', alpha2: 'AS', name: 'American Samoa' },
  { value: 'AND', alpha2: 'AD', name: 'Andorra' },
  { value: 'AGO', alpha2: 'AO', name: 'Angola' },
  { value: 'AIA', alpha2: 'AI', name: 'Anguilla' },
  { value: 'ATA', alpha2: 'AQ', name: 'Antarctica' },
  { value: 'ATG', alpha2: 'AG', name: 'Antigua and Barbuda' },
  { value: 'ARG', alpha2: 'AR', name: 'Argentina' },
  { value: 'ARM', alpha2: 'AM', name: 'Armenia' },
  { value: 'ABW', alpha2: 'AW', name: 'Aruba' },
  { value: 'AUS', alpha2: 'AU', name: 'Australia' },
  { value: 'AUT', alpha2: 'AT', name: 'Austria' },
  { value: 'AZE', alpha2: 'AZ', name: 'Azerbaijan' },
  { value: 'BHS', alpha2: 'BS', name: 'Bahamas' },
  { value: 'BHR', alpha2: 'BH', name: 'Bahrain' },
  { value: 'BGD', alpha2: 'BD', name: 'Bangladesh' },
  { value: 'BRB', alpha2: 'BB', name: 'Barbados' },
  { value: 'BLR', alpha2: 'BY', name: 'Belarus' },
  { value: 'BEL', alpha2: 'BE', name: 'Belgium' },
  { value: 'BLZ', alpha2: 'BZ', name: 'Belize' },
  { value: 'BEN', alpha2: 'BJ', name: 'Benin' },
  { value: 'BMU', alpha2: 'BM', name: 'Bermuda' },
  { value: 'BTN', alpha2: 'BT', name: 'Bhutan' },
  { value: 'BOL', alpha2: 'BO', name: 'Bolivia' },
  { value: 'BIH', alpha2: 'BA', name: 'Bosnia and Herzegovina' },
  { value: 'BWA', alpha2: 'BW', name: 'Botswana' },
  { value: 'BVT', alpha2: 'BV', name: 'Bouvet Island' },
  { value: 'BRA', alpha2: 'BR', name: 'Brazil' },
  { value: 'IOT', alpha2: 'IO', name: 'British Indian Ocean Territory' },
  { value: 'VGB', alpha2: 'VG', name: 'British Virgin Islands' },
  { value: 'BRN', alpha2: 'BN', name: 'Brunei' },
  { value: 'BGR', alpha2: 'BG', name: 'Bulgaria' },
  { value: 'BFA', alpha2: 'BF', name: 'Burkina Faso' },
  { value: 'BDI', alpha2: 'BI', name: 'Burundi' },
  { value: 'KHM', alpha2: 'KH', name: 'Cambodia' },
  { value: 'CMR', alpha2: 'CM', name: 'Cameroon' },
  { value: 'CAN', alpha2: 'CA', name: 'Canada' },
  { value: 'CPV', alpha2: 'CV', name: 'Cape Verde' },
  { value: 'BES', alpha2: 'BQ', name: 'Caribbean Netherlands' },
  { value: 'CYM', alpha2: 'KY', name: 'Cayman Islands' },
  { value: 'CAF', alpha2: 'CF', name: 'Central African Republic' },
  { value: 'TCD', alpha2: 'TD', name: 'Chad' },
  { value: 'CHL', alpha2: 'CL', name: 'Chile' },
  { value: 'CHN', alpha2: 'CN', name: 'China' },
  { value: 'CXR', alpha2: 'CX', name: 'Christmas Island' },
  { value: 'CCK', alpha2: 'CC', name: 'Cocos (Keeling) Islands' },
  { value: 'COL', alpha2: 'CO', name: 'Colombia' },
  { value: 'COM', alpha2: 'KM', name: 'Comoros' },
  { value: 'COK', alpha2: 'CK', name: 'Cook Islands' },
  { value: 'CRI', alpha2: 'CR', name: 'Costa Rica' },
  { value: 'HRV', alpha2: 'HR', name: 'Croatia' },
  { value: 'CUB', alpha2: 'CU', name: 'Cuba' },
  { value: 'CUW', alpha2: 'CW', name: 'Curaçao' },
  { value: 'CYP', alpha2: 'CY', name: 'Cyprus' },
  { value: 'CZE', alpha2: 'CZ', name: 'Czechia' },
  { value: 'DNK', alpha2: 'DK', name: 'Denmark' },
  { value: 'DJI', alpha2: 'DJ', name: 'Djibouti' },
  { value: 'DMA', alpha2: 'DM', name: 'Dominica' },
  { value: 'DOM', alpha2: 'DO', name: 'Dominican Republic' },
  { value: 'COD', alpha2: 'CD', name: 'DR Congo' },
  { value: 'ECU', alpha2: 'EC', name: 'Ecuador' },
  { value: 'EGY', alpha2: 'EG', name: 'Egypt' },
  { value: 'SLV', alpha2: 'SV', name: 'El Salvador' },
  { value: 'GNQ', alpha2: 'GQ', name: 'Equatorial Guinea' },
  { value: 'ERI', alpha2: 'ER', name: 'Eritrea' },
  { value: 'EST', alpha2: 'EE', name: 'Estonia' },
  { value: 'SWZ', alpha2: 'SZ', name: 'Eswatini' },
  { value: 'ETH', alpha2: 'ET', name: 'Ethiopia' },
  { value: 'FLK', alpha2: 'FK', name: 'Falkland Islands' },
  { value: 'FRO', alpha2: 'FO', name: 'Faroe Islands' },
  { value: 'FJI', alpha2: 'FJ', name: 'Fiji' },
  { value: 'FIN', alpha2: 'FI', name: 'Finland' },
  { value: 'FRA', alpha2: 'FR', name: 'France' },
  { value: 'GUF', alpha2: 'GF', name: 'French Guiana' },
  { value: 'PYF', alpha2: 'PF', name: 'French Polynesia' },
  { value: 'ATF', alpha2: 'TF', name: 'French Southern and Antarctic Lands' },
  { value: 'GAB', alpha2: 'GA', name: 'Gabon' },
  { value: 'GMB', alpha2: 'GM', name: 'Gambia' },
  { value: 'GEO', alpha2: 'GE', name: 'Georgia' },
  { value: 'DEU', alpha2: 'DE', name: 'Germany' },
  { value: 'GHA', alpha2: 'GH', name: 'Ghana' },
  { value: 'GIB', alpha2: 'GI', name: 'Gibraltar' },
  { value: 'GRC', alpha2: 'GR', name: 'Greece' },
  { value: 'GRL', alpha2: 'GL', name: 'Greenland' },
  { value: 'GRD', alpha2: 'GD', name: 'Grenada' },
  { value: 'GLP', alpha2: 'GP', name: 'Guadeloupe' },
  { value: 'GUM', alpha2: 'GU', name: 'Guam' },
  { value: 'GTM', alpha2: 'GT', name: 'Guatemala' },
  { value: 'GGY', alpha2: 'GG', name: 'Guernsey' },
  { value: 'GIN', alpha2: 'GN', name: 'Guinea' },
  { value: 'GNB', alpha2: 'GW', name: 'Guinea-Bissau' },
  { value: 'GUY', alpha2: 'GY', name: 'Guyana' },
  { value: 'HTI', alpha2: 'HT', name: 'Haiti' },
  { value: 'HMD', alpha2: 'HM', name: 'Heard Island and McDonald Islands' },
  { value: 'HND', alpha2: 'HN', name: 'Honduras' },
  { value: 'HKG', alpha2: 'HK', name: 'Hong Kong' },
  { value: 'HUN', alpha2: 'HU', name: 'Hungary' },
  { value: 'ISL', alpha2: 'IS', name: 'Iceland' },
  { value: 'IND', alpha2: 'IN', name: 'India' },
  { value: 'IDN', alpha2: 'ID', name: 'Indonesia' },
  { value: 'IRN', alpha2: 'IR', name: 'Iran' },
  { value: 'IRQ', alpha2: 'IQ', name: 'Iraq' },
  { value: 'IRL', alpha2: 'IE', name: 'Ireland' },
  { value: 'IMN', alpha2: 'IM', name: 'Isle of Man' },
  { value: 'ISR', alpha2: 'IL', name: 'Israel' },
  { value: 'ITA', alpha2: 'IT', name: 'Italy' },
  { value: 'CIV', alpha2: 'CI', name: 'Ivory Coast' },
  { value: 'JAM', alpha2: 'JM', name: 'Jamaica' },
  { value: 'JPN', alpha2: 'JP', name: 'Japan' },
  { value: 'JEY', alpha2: 'JE', name: 'Jersey' },
  { value: 'JOR', alpha2: 'JO', name: 'Jordan' },
  { value: 'KAZ', alpha2: 'KZ', name: 'Kazakhstan' },
  { value: 'KEN', alpha2: 'KE', name: 'Kenya' },
  { value: 'KIR', alpha2: 'KI', name: 'Kiribati' },
  { value: 'KWT', alpha2: 'KW', name: 'Kuwait' },
  { value: 'KGZ', alpha2: 'KG', name: 'Kyrgyzstan' },
  { value: 'LAO', alpha2: 'LA', name: 'Laos' },
  { value: 'LVA', alpha2: 'LV', name: 'Latvia' },
  { value: 'LBN', alpha2: 'LB', name: 'Lebanon' },
  { value: 'LSO', alpha2: 'LS', name: 'Lesotho' },
  { value: 'LBR', alpha2: 'LR', name: 'Liberia' },
  { value: 'LBY', alpha2: 'LY', name: 'Libya' },
  { value: 'LIE', alpha2: 'LI', name: 'Liechtenstein' },
  { value: 'LTU', alpha2: 'LT', name: 'Lithuania' },
  { value: 'LUX', alpha2: 'LU', name: 'Luxembourg' },
  { value: 'MAC', alpha2: 'MO', name: 'Macau' },
  { value: 'MDG', alpha2: 'MG', name: 'Madagascar' },
  { value: 'MWI', alpha2: 'MW', name: 'Malawi' },
  { value: 'MYS', alpha2: 'MY', name: 'Malaysia' },
  { value: 'MDV', alpha2: 'MV', name: 'Maldives' },
  { value: 'MLI', alpha2: 'ML', name: 'Mali' },
  { value: 'MLT', alpha2: 'MT', name: 'Malta' },
  { value: 'MHL', alpha2: 'MH', name: 'Marshall Islands' },
  { value: 'MTQ', alpha2: 'MQ', name: 'Martinique' },
  { value: 'MRT', alpha2: 'MR', name: 'Mauritania' },
  { value: 'MUS', alpha2: 'MU', name: 'Mauritius' },
  { value: 'MYT', alpha2: 'YT', name: 'Mayotte' },
  { value: 'MEX', alpha2: 'MX', name: 'Mexico' },
  { value: 'FSM', alpha2: 'FM', name: 'Micronesia' },
  { value: 'MDA', alpha2: 'MD', name: 'Moldova' },
  { value: 'MCO', alpha2: 'MC', name: 'Monaco' },
  { value: 'MNG', alpha2: 'MN', name: 'Mongolia' },
  { value: 'MNE', alpha2: 'ME', name: 'Montenegro' },
  { value: 'MSR', alpha2: 'MS', name: 'Montserrat' },
  { value: 'MAR', alpha2: 'MA', name: 'Morocco' },
  { value: 'MOZ', alpha2: 'MZ', name: 'Mozambique' },
  { value: 'MMR', alpha2: 'MM', name: 'Myanmar' },
  { value: 'NAM', alpha2: 'NA', name: 'Namibia' },
  { value: 'NRU', alpha2: 'NR', name: 'Nauru' },
  { value: 'NPL', alpha2: 'NP', name: 'Nepal' },
  { value: 'NLD', alpha2: 'NL', name: 'Netherlands' },
  { value: 'NCL', alpha2: 'NC', name: 'New Caledonia' },
  { value: 'NZL', alpha2: 'NZ', name: 'New Zealand' },
  { value: 'NIC', alpha2: 'NI', name: 'Nicaragua' },
  { value: 'NER', alpha2: 'NE', name: 'Niger' },
  { value: 'NGA', alpha2: 'NG', name: 'Nigeria' },
  { value: 'NIU', alpha2: 'NU', name: 'Niue' },
  { value: 'NFK', alpha2: 'NF', name: 'Norfolk Island' },
  { value: 'PRK', alpha2: 'KP', name: 'North Korea' },
  { value: 'MKD', alpha2: 'MK', name: 'North Macedonia' },
  { value: 'MNP', alpha2: 'MP', name: 'Northern Mariana Islands' },
  { value: 'NOR', alpha2: 'NO', name: 'Norway' },
  { value: 'OMN', alpha2: 'OM', name: 'Oman' },
  { value: 'PAK', alpha2: 'PK', name: 'Pakistan' },
  { value: 'PLW', alpha2: 'PW', name: 'Palau' },
  { value: 'PSE', alpha2: 'PS', name: 'Palestine' },
  { value: 'PAN', alpha2: 'PA', name: 'Panama' },
  { value: 'PNG', alpha2: 'PG', name: 'Papua New Guinea' },
  { value: 'PRY', alpha2: 'PY', name: 'Paraguay' },
  { value: 'PER', alpha2: 'PE', name: 'Peru' },
  { value: 'PHL', alpha2: 'PH', name: 'Philippines' },
  { value: 'PCN', alpha2: 'PN', name: 'Pitcairn Islands' },
  { value: 'POL', alpha2: 'PL', name: 'Poland' },
  { value: 'PRT', alpha2: 'PT', name: 'Portugal' },
  { value: 'PRI', alpha2: 'PR', name: 'Puerto Rico' },
  { value: 'QAT', alpha2: 'QA', name: 'Qatar' },
  { value: 'COG', alpha2: 'CG', name: 'Republic of the Congo' },
  { value: 'REU', alpha2: 'RE', name: 'Réunion' },
  { value: 'ROU', alpha2: 'RO', name: 'Romania' },
  { value: 'RUS', alpha2: 'RU', name: 'Russia' },
  { value: 'RWA', alpha2: 'RW', name: 'Rwanda' },
  { value: 'BLM', alpha2: 'BL', name: 'Saint Barthélemy' },
  { value: 'SHN', alpha2: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KNA', alpha2: 'KN', name: 'Saint Kitts and Nevis' },
  { value: 'LCA', alpha2: 'LC', name: 'Saint Lucia' },
  { value: 'MAF', alpha2: 'MF', name: 'Saint Martin' },
  { value: 'SPM', alpha2: 'PM', name: 'Saint Pierre and Miquelon' },
  { value: 'VCT', alpha2: 'VC', name: 'Saint Vincent and the Grenadines' },
  { value: 'WSM', alpha2: 'WS', name: 'Samoa' },
  { value: 'SMR', alpha2: 'SM', name: 'San Marino' },
  { value: 'STP', alpha2: 'ST', name: 'São Tomé and Príncipe' },
  { value: 'SAU', alpha2: 'SA', name: 'Saudi Arabia' },
  { value: 'SEN', alpha2: 'SN', name: 'Senegal' },
  { value: 'SRB', alpha2: 'RS', name: 'Serbia' },
  { value: 'SYC', alpha2: 'SC', name: 'Seychelles' },
  { value: 'SLE', alpha2: 'SL', name: 'Sierra Leone' },
  { value: 'SGP', alpha2: 'SG', name: 'Singapore' },
  { value: 'SXM', alpha2: 'SX', name: 'Sint Maarten' },
  { value: 'SVK', alpha2: 'SK', name: 'Slovakia' },
  { value: 'SVN', alpha2: 'SI', name: 'Slovenia' },
  { value: 'SLB', alpha2: 'SB', name: 'Solomon Islands' },
  { value: 'SOM', alpha2: 'SO', name: 'Somalia' },
  { value: 'ZAF', alpha2: 'ZA', name: 'South Africa' },
  { value: 'SGS', alpha2: 'GS', name: 'South Georgia' },
  { value: 'KOR', alpha2: 'KR', name: 'South Korea' },
  { value: 'SSD', alpha2: 'SS', name: 'South Sudan' },
  { value: 'ESP', alpha2: 'ES', name: 'Spain' },
  { value: 'LKA', alpha2: 'LK', name: 'Sri Lanka' },
  { value: 'SDN', alpha2: 'SD', name: 'Sudan' },
  { value: 'SUR', alpha2: 'SR', name: 'Suriname' },
  { value: 'SJM', alpha2: 'SJ', name: 'Svalbard and Jan Mayen' },
  { value: 'SWE', alpha2: 'SE', name: 'Sweden' },
  { value: 'CHE', alpha2: 'CH', name: 'Switzerland' },
  { value: 'SYR', alpha2: 'SY', name: 'Syria' },
  { value: 'TWN', alpha2: 'TW', name: 'Taiwan' },
  { value: 'TJK', alpha2: 'TJ', name: 'Tajikistan' },
  { value: 'TZA', alpha2: 'TZ', name: 'Tanzania' },
  { value: 'THA', alpha2: 'TH', name: 'Thailand' },
  { value: 'TLS', alpha2: 'TL', name: 'Timor-Leste' },
  { value: 'TGO', alpha2: 'TG', name: 'Togo' },
  { value: 'TKL', alpha2: 'TK', name: 'Tokelau' },
  { value: 'TON', alpha2: 'TO', name: 'Tonga' },
  { value: 'TTO', alpha2: 'TT', name: 'Trinidad and Tobago' },
  { value: 'TUN', alpha2: 'TN', name: 'Tunisia' },
  { value: 'TUR', alpha2: 'TR', name: 'Türkiye' },
  { value: 'TKM', alpha2: 'TM', name: 'Turkmenistan' },
  { value: 'TCA', alpha2: 'TC', name: 'Turks and Caicos Islands' },
  { value: 'TUV', alpha2: 'TV', name: 'Tuvalu' },
  { value: 'UGA', alpha2: 'UG', name: 'Uganda' },
  { value: 'UKR', alpha2: 'UA', name: 'Ukraine' },
  { value: 'ARE', alpha2: 'AE', name: 'United Arab Emirates' },
  { value: 'GBR', alpha2: 'GB', name: 'United Kingdom' },
  { value: 'USA', alpha2: 'US', name: 'United States' },
  { value: 'UMI', alpha2: 'UM', name: 'United States Minor Outlying Islands' },
  { value: 'VIR', alpha2: 'VI', name: 'United States Virgin Islands' },
  { value: 'URY', alpha2: 'UY', name: 'Uruguay' },
  { value: 'UZB', alpha2: 'UZ', name: 'Uzbekistan' },
  { value: 'VUT', alpha2: 'VU', name: 'Vanuatu' },
  { value: 'VAT', alpha2: 'VA', name: 'Vatican City' },
  { value: 'VEN', alpha2: 'VE', name: 'Venezuela' },
  { value: 'VNM', alpha2: 'VN', name: 'Vietnam' },
  { value: 'WLF', alpha2: 'WF', name: 'Wallis and Futuna' },
  { value: 'ESH', alpha2: 'EH', name: 'Western Sahara' },
  { value: 'YEM', alpha2: 'YE', name: 'Yemen' },
  { value: 'ZMB', alpha2: 'ZM', name: 'Zambia' },
  { value: 'ZWE', alpha2: 'ZW', name: 'Zimbabwe' },
]

/**
 * Derives the regional-indicator flag emoji for an ISO 3166-1 alpha-2 code,
 * e.g. flagEmoji('GB') -> '🇬🇧'.
 */
export function flagEmoji(alpha2: string): string {
  return alpha2
    .toUpperCase()
    .replace(/./g, (char) =>
      String.fromCodePoint(0x1f1e6 + char.charCodeAt(0) - 65)
    )
}
